module.exports = __webpack_public_path__ + "img/فروشگاه copy1.d0670e7c.jpg";